import { render, staticRenderFns } from "./SavedContentItemCard.vue?vue&type=template&id=1f8c0de0&scoped=true&"
import script from "./SavedContentItemCard.vue?vue&type=script&lang=js&"
export * from "./SavedContentItemCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8c0de0",
  null
  
)

export default component.exports